import ClassBase from '../../classBase';
import toast from '../../common/toast.jquery';
import smsCode from '../../common/smsCode.cardloan';
import checkMobile from '../../common/checkMobile.cardloan';
import regEvents from '../../register/events';
import * as es from '../../common/es';
import {report, reportBind} from '../../common/report';
import loginEvents from './login_events';
import ajax from '../../common/ajax.jquery';


class RequireMobileCodeForLayer extends ClassBase {
  constructor(opts) {
    super(opts);
    this.settings = es.objectAssign({
      regSubmitUrl: '',
      regSubmitParams: {},
      loginLink: '',
      source: '',
      success: function (data, type) {

      },
      isShowBubble:false,
      registerSubmitOptions: {},
      check_mobile: false,
      smsOptions: {},
      productType: 0,
      agreementName: '《小赢注册服务协议》',
      agreementLink: 'https://www.xiaoying.com/contract/previewById?id=940&previewSign=9794bf359b19965cea426cefe2ef7f7d&clean=0',
      btnCheckText: '立即注册',
      btnRegisterSubmitText: '我要拿钱',
      style: {},
      configExtend:{},
      templateId: '',
      showCaptchabox: true,
      hidePasswordbox: false,
      isImg:false,
      reportOldUser:{
        cmdid:55058,
        buttonid:8
      },
      reportConfig: {  //默认卡贷的CMDID，易贷等其他页面调用需设置
        pv: 55041,
        other: 55058,
      },
    }, this.settings);
    report({
      cmdid: this.settings.reportConfig.pv,

    });
  }

  init() {
    let source=this.settings.source
    require('./index.css');
    let tpl = require('./index.tpl.html');
    this.$html = $(tpl);
    this.$form = this.$html.find('.reg_form');
    this.$login = this.$html.find('.login-dialog');
    this.captchaImg = this.$form.find('.reg_captchaimg');//获取图形验证
    let doms = this.doms = {
      mobile: this.$form.find('.mobile'), //手机号
      password: this.$form.find('.password'),//密码
      captcha: this.$form.find('.captcha'),//图形验证码
      smsCode: this.$form.find('.smscode'),//短信验证码
      captchaBox: this.$form.find('.captchabox'), //图形验证
      loginMobile: this.$login.find('.in-box .phone-num'),//
      loginPassword: this.$login.find('.in-box .password'),//
      regLink: this.$html.find('.reg_agreeText .reg_link'),//
    };
    if(this.settings.isShowBubble){
      this.$html.find('#bubble').show();
    }else {
      this.$html.find('#bubble').hide();
    }
    let agreementSelected = this.settings.configExtend.agreementSelected == 1;
    let agreementIconObj = this.$form.find('.reg_checkbox');

    let color = this.settings.reg_checked_color;
    if (!color) {
      color = 'red';
    }
    //注册页协议获取
    ajax.get('/h5/common/get_contract_scene?sceneId=userRegister').then((data) => {
      let totalData = data.data.contractScene;
      totalData.contractList.forEach((item,index)=>{
        $('<a></a>').attr('href',item.contractUrl).addClass('agree-link').text(item.contractTitle).click(()=>{
          report({
            cmdid: this.settings.reportConfig.other,
            mobile: this.doms.mobile.val(),
            buttonid: 7
          });
        }).appendTo('.reg_agreeText')
      });
      if(this.settings.configExtend['arg_color']){
        $('.agree-link').css("color",this.settings.configExtend['arg_color']);
      }
      if (agreementSelected) {
        agreementIconObj.addClass('reg_checked_'+color);
      }else{
        agreementIconObj.removeClass('reg_checked_'+color);
      }

      agreementIconObj.on('click', () => {
        agreementSelected = !agreementSelected;
        agreementIconObj.toggleClass('reg_checked_'+color);
      })
    })
    // 自定义配置
    this.setCustomOption();
    if (this.settings.btnUp) {
      this.$form.find('.reg_btn_submit').insertBefore(this.$form.find('.reg_bottom'));
    }
    if(this.settings.isImg){
      this.$html.find('.reg_img').show();
    } else{
      this.$html.find('.reg_img').hide();
    }
    this.codeAni = null;
    let btnGetCode = this.$html.find('.reg_btn_getcode');
    let baseBtnSubmit = this.$html.find('.reg_btn_submit');

    this.btnGetCode = btnGetCode;
    this.baseBtnSubmit = baseBtnSubmit;
    let sendMobile = '';
    //获取验证码
    this.$html.find('.reg_btn_getcode').on('click', e => {

      if (this.codeAni) {
        return false;
      }
      this.codeAni = true;
      let param = {
        mobile: doms.mobile.val(),
        source: this.settings.source
      };
      if (this.captchaBoxShow || this.settings.showCaptchabox) {
        param.captchaCode = doms.captcha.val();
      }
      if (!param.mobile.match(/^(86){0,1}1\d{10}$/)) {
        toast('请输入正确的手机号码');
        this.codeAni = false;
        return;
      }

      if (param.hasOwnProperty('captchaCode') &&
        (!param.captchaCode || !param.captchaCode.match(/^\d{1,6}$/))) {
        toast('请输入图片验证码计算结果');
        this.codeAni = false;
        return false;
      }
      this.settings.reportOldUser.mobile = this.doms.mobile.val(),
      this.settings.smsOptions.reportOldUser = this.settings.reportOldUser;
      smsCode.send(param, es.objectAssign(this.settings.smsOptions,
        this.settings.registerSubmitOptions)).then(() => {
        sendMobile = param.mobile;
        // this.$form.filter('.base').find('.in').attr('disabled', true);
        let codeTime = 60;
        this.codeAni = setInterval(() => {
          codeTime--;
          if (codeTime < 0) {
            this.resetGetMobileCode(btnGetCode);
            return;
          }
          btnGetCode.text(codeTime + 's');
        }, 1000);
        btnGetCode.text(codeTime + 's');
      }).catch(e => {
        if (e.errCode == 0 && e.data.isNeedCaptcha) {
          this.showCaptcha();
        }
        this.codeAni = null;
        this.toggleImgcode();
        if (typeof this.settings.fail == 'function') {
          this.settings.fail.call(window, e, 'smscode');
        }
        // if (e.errCode == -27) {
        //   this.toggleImgcode();
        // } else if (e.errCode == -1000) {
        //   this.toggleImgcode();
        // }
      });
      e.preventDefault();
    });


    if (!this.settings.showCaptchabox) {
      doms.captchaBox.hide();
      if (this.settings.settingPosition) {
        this.$html.find('.reg_form').addClass('reg_settingPosition');
      }
    } else {
      this.toggleImgcode();
    }
    if (this.settings.hidePasswordbox) {
      doms.password.hide();
    }
    //注册
    baseBtnSubmit.on('click', e => {
      if (!agreementSelected) {
        toast('请同意' + this.settings.agreementName );
        return false;
      }
      let datas = es.objectAssign(this.settings.regSubmitParams || {}, {
        mobile: doms.mobile.val(),
        smsCode: doms.smsCode.val(),
        source: this.settings.source || '',
        _srcid: this.settings.source || '',
        templateId:this.settings.templateId||'',
        productType: this.settings.productType,
      });
      this.settings.registerSubmitOptions.hidePasswordbox = this.settings.hidePasswordbox;
      datas.password = doms.password.val()||'';
      regEvents.registerSubmit(this.settings.regSubmitUrl, datas, this.settings.registerSubmitOptions).then(e => {
        if (typeof this.settings.success == 'function') {
          this.settings.success.call(window, e, 'reg');
        }
      }).catch(e => {
        if (typeof this.settings.fail == 'function') {
          this.settings.fail.call(window, e, 'reg');
        }
      });

      e.preventDefault();
    });
    this.captchaImg.on('click', e => {
      this.toggleImgcode();
    });
    //点击已有账户啊
    this.$html.find('.reg_go_login').on('click', e => {
      report({
        cmdid: this.settings.reportConfig.other,
        buttonid: 7,
        mobile: doms.mobile.val(),
      });

      if(this.settings.loginShow){
        $('.login-dialog').show();
        report({
          cmdid: 55059,
          mobile: '',
        });
      }else {
        if (typeof this.settings.loginLink == 'string') {
          window.location.href = this.settings.loginLink;
        } else {
          this.settings.loginLink()
        }
      }


      e.preventDefault();
    });

    //点击登录
    this.$login.find('.btn-submit').bind('click', e => {
      report({
        cmdid: 55060,
        source: source,
        mobile: doms.loginMobile.val(),
        buttonid: 2
      });
      loginEvents.loginSubmit('https://cardloan.xiaoying.com/h5/user/login ', {
        username: doms.loginMobile.val(),
        password: doms.loginPassword.val(),
        os: 'h5',
        _srcid: source
      }).then(e => {
        if (typeof this.settings.loginLink == 'string') {
          window.location.href = this.settings.loginLink;
        }else {
          window.location.href=`https://cardloan.xiaoying.com/kadai/index.html?source=${source}`
        }
      }).catch(e => {});
      e.preventDefault();
    });
    //关闭登录
    this.$login.find('.btn_close').on('click', e => {
      $('.login-dialog').hide();
    });

    this.rBind();
  }
  rBind() {
    this.baseBtnSubmit.on('focus', e => {
      report({
        cmdid: this.settings.reportConfig.other,
        mobile: this.doms.mobile.val(),
        buttonid: 6
      });
      e.preventDefault();
    });
    this.btnGetCode.on('focus', e => {
      report({
        cmdid: this.settings.reportConfig.other,
        mobile: this.doms.mobile.val(),
        buttonid: 2
      });
      e.preventDefault();
    });
    this.doms.mobile.on('focus', e => {
      report({
        cmdid: this.settings.reportConfig.other,
        mobile: this.doms.mobile.val(),
        buttonid: 0
      });
      e.preventDefault();
    });
    this.doms.captcha.on('focus', e => {
      report({
        cmdid: this.settings.reportConfig.other,
        mobile: this.doms.mobile.val(),
        buttonid: 1
      });
      e.preventDefault();
    });
    this.doms.smsCode.on('focus', e => {
      report({
        cmdid: this.settings.reportConfig.other,
        mobile: this.doms.mobile.val(),
        buttonid: 3
      });
      e.preventDefault();
    });
    this.doms.password.on('focus', e => {
      report({
        cmdid: this.settings.reportConfig.other,
        mobile: this.doms.mobile.val(),
        buttonid: 4
      });
      e.preventDefault();
    });

    this.doms.loginMobile.on('focus', e => {
      report({
        cmdid: 55060,
        mobile: this.doms.loginMobile.val(),
        buttonid: 0
      });
      e.preventDefault();
    });
    this.doms.loginPassword.on('focus', e => {
      report({
        cmdid: 55060,
        mobile: this.doms.loginMobile.val(),
        buttonid: 1
      });
      e.preventDefault();
    });
  }

  resetGetMobileCode(btnGetCode) {
    // this.$form.filter('.base').find('.in').attr('disabled', false);
    btnGetCode.text('发送验证码');
    clearInterval(this.codeAni);
    this.codeAni = null;
  }

  showCaptcha() {
    this.doms.captchaBox.show();
    if (this.settings.settingPosition) {
      this.$html.find('.reg_form').removeClass('reg_settingPosition');
    }
    this.captchaBoxShow = true;
  }

  toggleImgcode() {
    let url = 'https://www.xiaoying.com/common/captcha?width=95&height=42&_r=' +
      new Date().getTime();
    this.captchaImg.attr('src', url);
    this.doms.captcha.val('');
  }

  setCustomOption() {
    if(this.settings.btnCheckText){
      this.$html.find('.reg_btn_submit').text(this.settings.btnCheckText);
    }
    Object.keys(this.settings.style).forEach((prop) => {
        this.$html.find('.' + prop).css(this.settings.style[prop]);
    });
    if (this.settings.reg_code) {
      if (this.settings.reg_code == 1) {
        this.$html.find('.reg_code').removeClass('reg_btnGetcode');
        this.$html.find('.reg_code').addClass('reg_btn_getcode');
      } else if (this.settings.reg_code == 2) {
        this.$html.find('.reg_code').removeClass('reg_btn_getcode');
        this.$html.find('.reg_code').addClass('reg_btnGetcode');
      }
    }
  }
}

export default function (opts) {
  let instance = new RequireMobileCodeForLayer(opts);
  instance.init();
  return instance;
}



// WEBPACK FOOTER //
// ./src/component/register/registerLowRate/index.js